import React from "react";
import { TagContainerStyled, AllTagContainer, Tag } from "./styled";
import { cn } from "utils/helpers";
export const TagContainer = ({ label, datas, labelClassName, ...props }) => {
	return (
		<TagContainerStyled>
			{label && (
				<h3 className={cn("mb-2 capitalize", labelClassName)}>{label}</h3>
			)}
			{datas?.length > 0 && (
				<AllTagContainer className="alltag">
					{datas?.map((data) => (
						<Tag key={data.id}>{data.name}</Tag>
					))}
				</AllTagContainer>
			)}
		</TagContainerStyled>
	);
};

export default TagContainer;
